import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ShActionItemComponent } from '../../../elements/components/action-item/action-item.component';
import { ShIconModule } from '../../../elements/components/icon/icon.module';

import { ShFormDualListBaseComponent } from './base/form-dual-list-base.component';
import { ShFormDualListComponent } from './main/form-dual-list.component';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, ShIconModule, ShActionItemComponent, ShFormDualListComponent, ShFormDualListBaseComponent],
    exports: [ShFormDualListComponent, ShFormDualListBaseComponent]
})
export class ShFormDualListModule {}

export { ShFormDualListBaseComponent } from './base/form-dual-list-base.component';
export { ShFormDualListComponent } from './main/form-dual-list.component';
